export const teacherLists = [
    {
      key: "1",
      img: "assets/img/teachers/teacher-01.jpg",
      id: "T849127",
      name: "Teresa",
      class: "III A",
      subject: "Physics",
      email: "teresa@example.com",
      phone: "+1 82392 37359",
      dateofJoin: "25 Mar 2024",
      status: "Active",
      statusclass: "badge badge-soft-success",
    },
    {
      key: "2",
      img: "assets/img/teachers/teacher-02.jpg",
      id: "T849126",
      name: "Daniel",
      class: "II (A)",
      subject: "Computer",
      email: "daniel@example.com",
      phone: "+1 56752 86742",
      dateofJoin: "28 Mar 2024",
      status: "Active",
      statusclass: "badge badge-soft-success",
    },
    {
      key: "3",
      img: "assets/img/teachers/teacher-05.jpg",
      id: "T849125",
      name: "Hellana",
      class: "VI (A)",
      subject: "English",
      email: "hellana@example.com",
      phone: "+1 23566 52683",
      dateofJoin: "11 Apr 2024",
      status: "Inactive",
      statusclass: "badge badge-soft-danger",
    },
    {
      key: "4",
      img: "assets/img/teachers/teacher-06.jpg",
      id: "T849124",
      name: "Erickson",
      class: "VI (B) , V (A)",
      subject: "Spanish",
      email: "erickson@example.com",
      phone: "+1 14259 85573",
      dateofJoin: "16 Apr 2024",
      status: "Inactive",
      statusclass: "badge badge-soft-danger",
    },
    {
      key: "5",
      img: "assets/img/teachers/teacher-07.jpg",
      id: "T849123",
      name: "Morgan",
      class: "VIII",
      subject: "Env Science",
      email: "morgan@example.com",
      phone: "+1 63204 35730",
      dateofJoin: "20 Apr 2024",
      status: "Active",
      statusclass: "badge badge-soft-success",
    },
    {
      key: "6",
      img: "assets/img/teachers/teacher-06.jpg",
      id: "T849122",
      name: "Aaron",
      class: "I (A)",
      subject: "Chemistry",
      email: "aaron@example.com",
      phone: "+1 26267 80542",
      dateofJoin: "12 May 2024",
      status: "Active",
      statusclass: "badge badge-soft-success",
    },
    {
      key: "7",
      img: "assets/img/teachers/teacher-09.jpg",
      id: "T849121",
      name: "Jacquelin",
      class: "IV",
      subject: "Maths",
      email: "jacquelin@example.com",
      phone: "+1 77502 54845",
      dateofJoin: "20 May 2024",
      status: "Active",
      statusclass: "badge badge-soft-success",
    },
    {
      key: "8",
      img: "assets/img/students/student-10.jpg",
      id: "T849120",
      name: "Raul",
      class: "IX",
      subject: "Biology",
      email: "raul@example.com",
      phone: "+1 67845 78784",
      dateofJoin: "27 May 2024",
      status: "Inactive",
      statusclass: "badge badge-soft-danger",
    },
    {
      key: "9",
      img: "assets/img/students/student-11.jpg",
      id: "T849119",
      name: "Elizabeth",
      class: "VII",
      subject: "Economics",
      email: "elizabeth@example.com",
      phone: "+1 97846 84518",
      dateofJoin: "10 Jun 2024",
      status: "Active",
      statusclass: "badge badge-soft-success",
    },
    {
      key: "10",
      img: "assets/img/teachers/teacher-03.jpg",
      id: "T849118",
      name: "Edward",
      class: "IX (C) , X (C)",
      subject: "Finance",
      email: "edward@example.com",
      phone: "+1 56187 87489",
      dateofJoin: "18 Jun 2024",
      status: "Active",
      statusclass: "badge badge-soft-success",
    },
    {
      key: "11",
      img: "assets/img/teachers/teacher-04.jpg",
      id: "T849117",
      name: "Maria",
      class: "I (A)",
      subject: "English",
      email: "maria@example.com",
      phone: "+1 97846 84518",
      dateofJoin: "22 Mar 2018",
      status: "Active",
      statusclass: "badge badge-soft-success",
    },
  ];